<script setup>
import { useAxios } from '@/hooks/useAxios';
import { useCommonCodeStore } from '@/store/commoncode-store';
import { computed, nextTick, ref, watch } from 'vue';
let BASE_URL = import.meta.env.VITE_APP_API_URL;
// Props 정의
const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },

    htmlTemplate: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    visible: {
        type: Boolean,
        default: true
    },
    dataList: {
        type: [Array, Object],
        default: () => []
    },
    params: {
        type: String,
        default: ''
    }
});

const garageName = ref('');
let options = ref([]);
const selectedValue = ref('');
const compSelectedValue = ref('');
const params = ref(props.params);

watch(
    selectedValue,
    (newValue) => {
        compSelectedValue.value = newValue; // 변경된 값을 반영
    },
    { immediate: true }
);

const emit = defineEmits(['update:modelValue', 'input', 'enter', 'item-select', 'update-options']);

const commonCodes = computed(() => useCommonCodeStore().getCommonCodes);

const commonCode = (code) => {
    const returnVal = computed(() => {
        return commonCodes.value[code];
    });
    return returnVal;
};

const searchGarage = async (param) => {
    const config = { method: 'get' };
    console.log('searchGarage param');
    console.log(param);
    try {
        const { execute } = useAxios(`/api/garage/${param}`, config, {
            immediate: false,
            onSuccess(response) {
                console.log(response);
                const newList = response.data.data.map((item) => ({
                    value: item.garage_id,
                    garage_name: item.garage_name,
                    phone: item.phone || '',
                    address: item.address || '',
                    address_detail: item.address_detail || ''
                }));
                console.log(newList[0]['garage_name']);
                garageName.value = newList[0]['garage_name'] || [];
            },
            onError(err) {
                console.error('Error:', err.message);
                garageName.value = [];
            }
        });
        await execute();
    } catch (err) {
        console.error(err);
        garageData.value = [];
    }
};

let dataList = computed(() => props.dataList);

watch(
    () => props.dataList,
    (newData) => {
        console.log('dataList newData>>>');
        console.log(newData);
        if (newData && Object.hasOwn(newData, 'contract_list') && newData.contract_list.length > 0) {
            let contractId = newData.replace_contract_no_list;
            console.log('contractId>>');
            console.log(contractId);
            options.value = contractId;
            selectedValue.value = newData.contract_list[0]['contract_no'];
        }
    },
    { deep: true, immediate: true }
);

watch(
    () => props.params,
    (newData) => {
        if (!newData == false) {
            console.log(newData);
            selectedValue.value = newData;
        }
    },
    { deep: true, immediate: true }
);

const compiledTemplate = computed(() => {
    console.log('dataList.value>>>');
    console.log('📄 템플릿 재컴파일:', selectedValue.value);
    console.log(dataList.value);
    let template = props.htmlTemplate;
    let contractList = dataList.value.contract_list || [];
    let selectedContract = contractList.find((contract) => contract.contract_no === selectedValue.value);

    if (!selectedContract && dataList.value.length > 0) {
        console.log('⚠️ 선택된 계약서 없음');
        selectedValue.value = dataList.value.contract_list[0]['contract_no'];
    }
    for (const [key, val] of Object.entries(dataList.value)) {
        let value = val;

        let placeholder = `{{${key}}}`;
        let placeholderNum = `{{${key}}}num`;
        let placeholderPhone = `{{${key}}}phone`;
        let placeholderCustomerType = `{{${key}}}customer_type`;
        let placeholderColType = `{{${key}}}collisiontype`;
        let placeholderColState = `{{${key}}}insureState`;
        let placeholderInsuranceCompany = `{{${key}}}insurance_company`;

        let regex = new RegExp(placeholder, 'g');
        let regexNum = new RegExp(placeholderNum, 'g');
        let regexPhone = new RegExp(placeholderPhone, 'g');
        let regexCustomerType = new RegExp(placeholderCustomerType, 'g');
        let regexColType = new RegExp(placeholderColType, 'g');
        let regexColState = new RegExp(placeholderColState, 'g');
        let regexInsuranceCompany = new RegExp(placeholderInsuranceCompany, 'g');

        // 계약서 노트
        if (key === 'contract_note_list') {
            let placeholder2 = `<tr><td>{{contract_no}}</td><td>{{note}}</td><td>{{date_time}}</td><td>{{writer}}</td></tr>`;
            let rows = val
                .map((data) => {
                    return placeholder2.replace(/{{(.*?)}}/g, (_, placeholder) => {
                        return data[placeholder] || '';
                    });
                })
                .join('');
            let regtext = /{{note_list_detail}}/g;
            template = template.replace(regtext, rows);
        }
        //결제 메모
        if (key === 'payment_item_list') {
            let placeholder2 = ` <tr>
                                <td>{{payment_date}}</td>
                                <td>{{payment_time}}</td>
                                <td>{{payment_amount}}</td>
                                <td>{{payment_category}}</td>
                                <td>{{payment_category_name}}</td>
                                <td>{{payment_method}}</td>
                                <td>{{remark}}</td>
                            </tr>`;
            let rows = val
                .map((data) => {
                    return placeholder2.replace(/{{(.*?)}}/g, (_, placeholder) => {
                        let val = data[placeholder] || '';
                        console.log('pament item list placeholder');
                        console.log(placeholder);
                        if (placeholder === 'payment_amount') {
                            val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 문자열로 숫자일 경우 정규식으로 콤마 추가
                        } else if (placeholder === 'payment_category') {
                            let options = commonCode('PAYMENT_CATEGORY').value;
                            options && options.length > 0
                                ? options.map((c, i) => {
                                      if (c.value == val) {
                                          val = c.text;
                                      }
                                  })
                                : '';
                        } else if (placeholder === 'payment_method') {
                            let options = commonCode('PAYMENT_METHOD').value;
                            options && options.length > 0
                                ? options.map((c, i) => {
                                      if (c.value == val) {
                                          val = c.text;
                                      }
                                  })
                                : '';
                        }

                        return val;
                    });
                })
                .join('');
            let regtext = /{{payment_item_list_detail}}/g;
            template = template.replace(regtext, rows);
        }
        //계약서 리스트
        if (key === 'contract_list' && dataList.value[key].length > 0) {
            dataList.value[key].map((data, i) => {
                //선택한 값이 일치한 데이터만 표출될 수 있도록 한다.
                console.log('data.contract_no>>>>>>>>');
                console.log(data.contract_no);
                console.log(selectedValue.value);
                if (data.contract_no === selectedValue.value) {
                    for (const [key2, value2] of Object.entries(data)) {
                        let val = value2;
                        let placeholder2 = `{{${key2}}}`;
                        let placeholder2Num = `{{${key2}}}num`;
                        let placeholder2Fual = `{{${key2}}}fual`;

                        if (key2 === 'garage_id') {
                            searchGarage(value2);
                            val = garageName.value;
                        }
                        if (key2 === 'delivery_state') {
                            let options = commonCode('USE_STATE').value;
                            options && options.length > 0
                                ? options.map((c, i) => {
                                      if (c.value == val) {
                                          val = c.text;
                                      }
                                  })
                                : '';
                        }

                        if (key2 == 'contract_attachment_list') {
                            //렌터카 외관
                            let realKey = 'rental_vehicle';
                            placeholder2 = `{{${realKey}}}`;
                            let href = '';
                            val.map((val, i) => {
                                console.log(val);
                                let realVal = val['attachment_filename'];
                                let imageOriginName = val['original_filename'];
                                let imageVal = `${BASE_URL}/view/${realVal}`;
                                href += `<a href="${imageVal}" target="_blank"
                                style="display: block; text-decoration: none; color: black; margin: 5px 0; transition: color 0.3s;"
                                onmouseover="this.style.color='blue'"
                                onmouseout="this.style.color='black'">
                                🔍 ${imageOriginName}
                            </a>`;
                                // href += `<a
                                //     onclick="event.preventDefault();
                                //     let imgWindow = window.open('', '_blank', 'width=200,height=200,resizable=yes,scrollbars=no,status=no,toolbar=no,menubar=no,location=no');
                                //     imgWindow.document.write('<html><head><title>이미지</title></head><body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background-color:black;"><img src="${imageVal}" style="max-width:210px; max-height:210px;"></body></html>
                                // </a>`;
                            });
                            // href = `<div style="display: flex; justify-content: center; align-items: center; gap: 10px; flex-wrap: wrap; flex-direction: row; max-width: 100%; overflow: hidden;">${href}</div>`;
                            href = `<div style="display: flex; flex-direction: column; align-items: flex-start; gap: 5px;">${href}</div>`;
                            val = href;
                        }
                        let regexNum2 = new RegExp(placeholder2Num, 'g');
                        if (regexNum2.test(template)) {
                            let formattedValue;
                            if (typeof val === 'number') {
                                formattedValue = val.toLocaleString(); // 숫자에 천 단위 콤마 추가
                            } else if (typeof val === 'string' && !isNaN(val)) {
                                formattedValue = val.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 문자열로 숫자일 경우 정규식으로 콤마 추가
                            } else {
                                formattedValue = val; // 숫자가 아니면 원래 값 그대로
                            }
                            template = template.replace(regexNum2, formattedValue);
                        }

                        let regexFualType = new RegExp(placeholder2Fual, 'g');
                        //유종 공통코드
                        if (regexFualType.test(template)) {
                            let options = commonCode('FUEL_TYPE').value;
                            let value = '';
                            options && options.length > 0
                                ? options.map((c, i) => {
                                      if (c.value == val) {
                                          value = c.text;
                                      }
                                  })
                                : '';
                            template = template.replace(regexFualType, value);
                        }

                        regex = new RegExp(placeholder2, 'g');
                        template = template.replace(regex, val);
                    }
                }
            });
        }
        //계약서 이미지 리스트
        if (key === 'reservation_attachment_list') {
            if (dataList.value[key].length > 0) {
                let categorizedData = [];
                dataList.value[key].forEach((item) => {
                    let category = item.attachment_category;
                    if (!categorizedData[category]) {
                        categorizedData[category] = [];
                    }
                    categorizedData[category].push(item);
                });

                for (const [k, v] of Object.entries(categorizedData)) {
                    let realKey = k;
                    let href = '';

                    v.forEach((val, i) => {
                        console.log(val);
                        let realVal = val['attachment_filename'];
                        let imageOriginName = val['original_filename'];
                        let imageVal = `${BASE_URL}/view/${realVal}`;

                        href += `<a href="${imageVal}" target="_blank"
                    style="display: block; text-decoration: none; color: black; margin: 5px 0; transition: color 0.3s;"
                    onmouseover="this.style.color='blue'"
                    onmouseout="this.style.color='black'">
                    🔍 ${imageOriginName}
                 </a>`;

                        // `<a href="${imageVal}" target="_blank" style="display: block; text-decoration: none; margin: 5px 0;">
                        //             🔍 ${imageOriginName}
                        //          </a>`;
                    });

                    href = `<div style="display: flex; flex-direction: column; align-items: flex-start; gap: 5px;">${href}</div>`;

                    let placeholder2 = `{{${realKey}}}`;
                    let regex = new RegExp(placeholder2, 'g');
                    template = template.replace(regex, href);
                }

                // for (const [k, v] of Object.entries(categorizedData)) {
                //     let realKey = k;

                //     let href = ''
                //     v.map((val,i)=>{
                //         let realVal = val['attachment_filename'];
                //         let imageVal = `${BASE_URL}/view/${realVal}`;
                //         href += `<a
                //             onclick="event.preventDefault();
                //             let imgWindow = window.open('', '_blank', 'width=200,height=200,resizable=yes,scrollbars=no,status=no,toolbar=no,menubar=no,location=no');
                //             imgWindow.document.write('<html><head><title>이미지</title></head><body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background-color:black;"><img src="${imageVal}" style="max-width:210px; max-height:210px;"></body></html>
                //         </a>`;
                //     })
                //     href = `<div style="display: flex; justify-content: center; align-items: center; gap: 10px; flex-wrap: wrap; flex-direction: row; max-width: 100%; overflow: hidden;">${href}</div>`;

                //     let placeholder2 = `{{${realKey}}}`;
                //     regex = new RegExp(placeholder2, 'g');
                //     template = template.replace(regex,  href);
                // }
            } else {
                //이미지 없는 항목들 보이지않도록 설정
                let emptyImage = ['contract_document', 'customer_signature'];
                emptyImage.map((im) => {
                    let placeholderImage = `{{${im}}}`;
                    regex = new RegExp(placeholderImage, 'g');
                    template = template.replace(regex, '');
                });
            }
        }
        //넘터 타입 변경건
        if (regexNum.test(template)) {
            let formattedValue;
            if (typeof value === 'number') {
                formattedValue = value.toLocaleString(); // 숫자에 천 단위 콤마 추가
            } else if (typeof value === 'string' && !isNaN(value)) {
                formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 문자열로 숫자일 경우 정규식으로 콤마 추가
            } else {
                formattedValue = value; // 숫자가 아니면 원래 값 그대로
            }
            if (formattedValue == '-1') {
                console.log('formattedValue>>>');
                console.log(formattedValue);
                formattedValue = '무한';
            }
            template = template.replace(regexNum, formattedValue);
        }

        //전화번호 정규식
        if (regexPhone.test(template)) {
            let formattedValue = value.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
            template = template.replace(regexPhone, formattedValue);
        }

        //고객구분 공통코드
        if (regexCustomerType.test(template) && key === 'customer_type') {
            let options = commonCode('CUSTOMER_TYPE').value;
            //고객구분이 개인일경우 법인 항목이 보이지 않도록 설정
            if (val === 'INDV') {
                let displayCustomerType = `valid_customer_type`;
                let regexDispCustomerType = new RegExp(displayCustomerType, 'g');

                displayCustomerType = 'is_customer_type';
                template = template.replace(regexDispCustomerType, displayCustomerType);
            }
            let value = '';
            options && options.length > 0
                ? options.map((c, i) => {
                      if (c.value == val) {
                          value = c.text;
                      }
                  })
                : '';

            template = template.replace(regexCustomerType, value);
        }

        //자차보험 공통코드
        if (regexColType.test(template) && key === 'collision_coverage_type') {
            let options = commonCode('COLLISION_COVERAGE_TYPE').value;
            let value = '';
            options && options.length > 0
                ? options.map((c, i) => {
                      if (c.value == val) {
                          value = c.text;
                      }
                  })
                : '';
            template = template.replace(regexColType, value);
        }

        //자차보험 면책금 구분
        if (regexColState.test(template) && key === 'collision_insurance_state') {
            let options = commonCode('COLLISION_INSURANCE_STATE').value;
            let value = '';
            options && options.length > 0
                ? options.map((c, i) => {
                      if (c.value == val) {
                          value = c.text;
                      }
                  })
                : '';
            template = template.replace(regexColState, value);
        }
        //보험사 공통코드
        if (regexInsuranceCompany.test(template) && key === 'insurance_company') {
            let options = commonCode('INSURANCE_COMPANY').value;
            let value = '';
            options && options.length > 0
                ? options.map((c, i) => {
                      if (c.value == val) {
                          value = c.text;
                      }
                  })
                : '';
            template = template.replace(regexInsuranceCompany, value);
        }

        //제 2운전자 보이지 않도록
        let displaySecondDriver = `valid_second_driver`;
        let regSecondDriver = new RegExp(displaySecondDriver, 'g');

        if (key === 'is_second_driver' && regSecondDriver.test(template)) {
            if (value === 'N') {
                displaySecondDriver = 'is_second_driver';
                template = template.replace(regSecondDriver, displaySecondDriver);
            }
        }

        template = template.replace(regex, value);
    }
    return template;
});
const onItemSelect = (event) => {
    dataList.value = [];
    nextTick(() => {
        selectedValue.value = event.target.value;
    });

    emit('input', { id: props.inputId, value: selectedValue.value });
    emit('update:modelValue', selectedValue);
};
const onItemSelect2 = (event) => {
    console.log('🔄 선택onItemSelect2된 계약서 번호:', event.target.value); // 값이 제대로 출력되는지 확인
    selectedValue.value = '';
    nextTick(() => {
        selectedValue.value = event.target.value;
        test2.value = Date.now();
        keyValue.value = Date.now();
    });

    setTimeout(() => {
        keyValue.value = Date.now();
    }, 100);

    emit('input', { id: props.inputId, value: selectedValue });
    emit('update:modelValue', selectedValue);
};
</script>

<template>
    <!-- {{ selectedValue }} -->
    <!-- {{ selectedValue }} |||
    {{ compSelectedValue }} -->
    <div>
        <div class="pl-[4rem]">
            <label for="selectBox">종결 계약서 선택 : </label>
            <select id="selectBox" v-model="selectedValue" @change="onItemSelect" class="border p-2 rounded w-[20rem]">
                <option v-for="option in options" :key="option" :value="option">
                    {{ option }}
                </option>
            </select>
        </div>
        <div
            v-if="visible"
            class="flex items-center"
            :style="{
                marginTop: marginTop,
                marginBottom: marginBottom,
                marginLeft: marginLeft,
                marginRight: marginRight
            }"
        >
            <div class="relative html-content">
                <div v-if="visible" v-html="compiledTemplate" :key="selectedValue"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.label-text {
    font-family: 'SCoreDream500';
    font-size: 0.95rem;
    color: #374151;
    width: 100%;
}

.label-required {
    color: #f87171;
}

.label-required::after {
    content: '*';
    color: #f87171;
    margin-left: 0.25rem;
    margin-right: 0.2rem;
}

input:focus {
    border-color: #0038ea;
    outline: none;
}

.html-content {
    width: 100%;
    font-family: 'SCoreDream400';
    padding-top: 0.18rem;
    font-size: 0.9rem;
    color: #111827;
}
legend {
    font-size: 1rem;
    font-family: 'SCoreDream500';
    flex-shrink: 0;
    padding: 1.3rem 0 0 0;
}
.note-grid {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
}

.note-grid th,
.note-grid td {
    border: 0.1rem solid #ddd;
    border-left: none;
    border-right: none;
    padding: 0.3rem;
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    text-align: center;
    max-width: 15rem;
}

.note-grid th {
    background-color: #f2f2f2;
}

.note-grid tr:nth-child(even) {
    background-color: #f9f9f9;
}

.note-grid th:hover {
    cursor: default;
}

.note-grid tr:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}
</style>
